import React, { useState } from 'react';
import { CreditCard } from 'lucide-react';
import { paymentTypes } from '../../data/mockData';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const ReceiveCash = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    amount: '',
    paymentType: '',
    agentName: ''
  });
  const creationDisabled = true;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (creationDisabled) {
      toast.warn(t('payments.creationDisabled'));
      return;
    }
    try {
      console.log('Cash received:', formData);
      toast.success(t('receiveCash.paymentRecorded'));
      setFormData({ amount: '', paymentType: '', agentName: '' });
    } catch (err) {
      toast.error(t('receiveCash.paymentError'));
    }
  };

  return (
    <div className="max-w-4xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-8">
        {t('receiveCash.title')}
      </h1>

      <div className="bg-white dark:bg-gray-800 shadow-lg rounded-lg p-6">
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label htmlFor="amount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                {t('receiveCash.amount')}
              </label>
              <div className="relative">
                <input
                  id="amount"
                  name="amount"
                  type="number"
                  value={formData.amount}
                  onChange={handleChange}
                  required
                  className="w-full pl-8 rtl:pl-3 rtl:pr-8 pr-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors duration-200"
                  placeholder="0.00"
                />
              </div>
            </div>
            <div>
              <label htmlFor="paymentType" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                {t('receiveCash.paymentType')}
              </label>
              <select
                id="paymentType"
                name="paymentType"
                value={formData.paymentType}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors duration-200"
              >
                <option value="">{t('receiveCash.selectPaymentType')}</option>
                {paymentTypes.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="md:col-span-2">
              <label htmlFor="agentName" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                {t('receiveCash.agentName')}
              </label>
              <input
                id="agentName"
                name="agentName"
                type="text"
                value={formData.agentName}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors duration-200"
                placeholder={t('receiveCash.agentNamePlaceholder')}
              />
            </div>
            <div className="md:col-span-2 pt-4">
              <button
                type="submit"
                disabled={creationDisabled}
                title={creationDisabled ? t('common.warning') : t('receiveCash.recordButton')}
                className="w-full md:w-auto inline-flex items-center justify-center px-6 py-3 bg-primary-600 dark:bg-primary-700 text-white font-medium rounded-lg hover:bg-primary-700 dark:hover:bg-primary-600 focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 transition-colors duration-200 disabled:opacity-60"
              >
                <CreditCard className="h-5 w-5 mr-2 rtl:mr-0 rtl:ml-2" />
                {t('receiveCash.recordButton')}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReceiveCash;